import AddTemplate from "../_templates/AddTemplate";
import { tournamentSchema } from "../../../schemas/tournament.schema";
import { createTournament } from "../../../api/tournament.api";

export default function AddTournament() {
  return (
    <AddTemplate
      title="Add Tournament"
      schema={tournamentSchema}
      createFn={createTournament}
      redirectPath="/cricket/tournaments"
    />
  );
}
